import { Box, FormControlLabel, Stack, Typography } from '@mui/material';
import { CustomizedSwitches } from '../../Switch/Switch';
import { FONT_ENUM } from '../../../types/global/fonts.types';
import type { ThemeStyle } from '../../../module/ThemeManager';
import { Colors } from '../../../constants/theme';

export interface EditProfileConfigTabProps {
    hideRateCard: boolean;
    onHideRateCardChange: (value: boolean) => void;
    themeTokens: Colors;
    themeStyle: ThemeStyle;
}

export function EditProfileConfigTab({
    hideRateCard,
    onHideRateCardChange,
    themeTokens,
    themeStyle,
}: EditProfileConfigTabProps) {
    return (
        <Stack spacing={3}>
            <Typography
                variant="subtitle1"
                sx={{
                    fontFamily: FONT_ENUM.MAIN_BOLD,
                    color: themeTokens.primary_white,
                }}>
                Profile configuration
            </Typography>

            <Box
                sx={{
                    p: 2,
                    borderRadius: 1.5,
                    bgcolor: themeStyle === 'dark' ? '#1a1919' : themeTokens.form_divider,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: 2,
                }}>
                <Box sx={{ minWidth: 0 }}>
                    <Typography
                        sx={{
                            fontFamily: FONT_ENUM.MAIN_BOLD,
                            color: themeTokens.primary_white,
                            fontSize: 14,
                        }}>
                        Hide rate card on public profile
                    </Typography>
                    <Typography
                        sx={{
                            fontFamily: FONT_ENUM.MAIN_REGULAR,
                            color: themeTokens.form_label,
                            fontSize: 12,
                            mt: 0.5,
                            lineHeight: 1.5,
                        }}>
                        When enabled, brands must request a custom quotation before viewing your tiered pricing.
                    </Typography>
                </Box>
                <FormControlLabel
                    sx={{ m: 0, flexShrink: 0 }}
                    label=""
                    control={
                        <CustomizedSwitches
                            switchProps={{
                                checked: hideRateCard,
                                onChange: e => onHideRateCardChange(e.target.checked),
                            }}
                        />
                    }
                />
            </Box>
        </Stack>
    );
}
